import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbAlertModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { HireSearchService } from '../../services/hire-search.service';
import { CandidateService } from 'src/app/_services/candidate.service';
import { environment } from 'src/environments/environment';
import { CustomValidator } from 'src/app/_services/customValidator';

@Component({
  selector: 'app-hire-files',
  imports: [NgbCollapseModule, NgbAlertModule],
  templateUrl: './hire-files.component.html',
  styleUrl: './hire-files.component.scss',
})
export class HireFilesComponent implements OnInit, OnChanges {
  isCollapsed: boolean = false
  isCollapsed2: boolean = false
  isCollapsed3: boolean = false;
  incorrectFileFormat: boolean = false;
  fileUploadSpinner: boolean = false;
  iscvDetailsLoader: boolean = false;
  cvDetails: any[] = []
  @Input() candidateId: any

  successMessage: string = '';
  errorMessage: string = '';
  @Input() calledFrom: string = '';
  /**
   * Notifies the parent (side panel -> slider) that a file was added or removed, so the
   * Activity tab can refetch and show the new entry in real time.
   */
  @Output() filesUpdated = new EventEmitter<any>();
  constructor(private hireSearchService: HireSearchService, private candidateService: CandidateService) { }

  ngOnInit() {
    if (this.calledFrom == 'pipeline-list') {
      this.getCandidatedocuments()
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['candidateId'] && !changes['candidateId'].firstChange) {

      if (this.calledFrom == 'pipeline-list') {
        this.cvDetails = [];
        this.getCandidatedocuments();

      }
    }
  }

  uploadFile(e) {
    const resumeFile = e.target.files[0]
    this.incorrectFileFormat = !CustomValidator.isValidDocumentExtension(resumeFile.name);
    if (this.incorrectFileFormat) {
      this.showToastMessage('Unsupported file format. Allowed: doc, docx, txt, pdf, dot, rtf, odt', 'error');
      e.target.value = '';
      return;
    }
    this.fileUploadSpinner = true;
    this.hireSearchService.uploadresume(resumeFile).subscribe((res: any) => {
      if (res.status !== 'success') {
        this.fileUploadSpinner = false;
        this.showToastMessage(res.message || 'Failed to upload document', 'error');
        e.target.value = '';
        return;
      }
          this.incorrectFileFormat = false
            const data = {
              candidatenumber: this.candidateId,
              cvfilesarray: [{
                filename: res.filename,
                docurl: res.docurl,
                previewurl: res.previewurl,
                isactive: 1
              }],
              cvactivitylog: [{
                "action": "'added'",
                "type": "'CV'",
                "oldvalue": "'" + res.filename + "'",
              }]
            }
            this.hireSearchService.savecvfiles(data).subscribe((res: any) => {
              this.getCandidatedocuments()
              this.showToastMessage('Document added Successfully', 'success')
              this.fileUploadSpinner = false;
              this.filesUpdated.emit(this.candidateId);

              //- Clevertap Upload Document event
              // let ctObj = {
              //   "Name": this.basicdDetails.firstname + " " + this.basicdDetails.lastname,
              //   "Job title": this.basicdDetails.jobtitle,
              //   "Company Name": this.basicdDetails.companyname,
              //   "Source": this.basicdDetails.source,
              //   "Location": this.basicdDetails.locationname,
              //   "Origin": "Web app"
              // }
              // this.cleverTapEvent("Upload Document", ctObj);
            })
      }, (_) => {
        this.fileUploadSpinner = false;
        this.showToastMessage('Failed to upload document', 'error');
      })
  }

  /**
 * Get candidate documents based on candidate id
 */
  getCandidatedocuments() {
    this.iscvDetailsLoader = true;
    this.hireSearchService.fetchcvdetails(this.candidateId).subscribe((res: any) => {
      if (res.status == 'success') {
        this.iscvDetailsLoader = false;
        this.cvDetails = res.cvdetails;

      }
    })
  }

  /**
 * Show toast message
 * @param message
 * @param type
 */
  showToastMessage(message: string, type: string) {
    const messageType = type;
    switch (messageType) {
      case 'success': this.successMessage = message;
        setTimeout(() => this.successMessage = '', 5000);
        break;
      case 'error': this.errorMessage = message;
        setTimeout(() => this.errorMessage = '', 5000);
        break;
    }
  }

  deleteCV(file) {
    const selectedCV = file;
    const data = {
      candidatenumber: this.candidateId,
      cvfilesarray: [{
        filename: selectedCV.filename,
        docurl: selectedCV.docurl,
        previewurl: selectedCV.previewurl,
        isactive: 0,
        candidatedocid: selectedCV.candidatedocid
      }],
      cvactivitylog: [{
        action: "'removed'",
        type: "'CV'",
        oldvalue: "'" + selectedCV.filename + "'",
        candidatedocid: "'" + selectedCV.candidatedocid + "'"
      }]
    }
    this.candidateService.savecvfiles(data).subscribe((res: any) => {
      this.getCandidatedocuments();
      this.showToastMessage('Document removed Successfully', 'success');
      this.filesUpdated.emit(this.candidateId);
    })
  }

  downloadCV(dt) {
    const downloadLink = document.createElement("a");
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", environment.backendurl + "/candidate/fetchdocument?documenturl=" + dt.previewurl);
    downloadLink.setAttribute("download", "fileName");
    downloadLink.setAttribute("target", "_blank");
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

    previewFile(file) {
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", environment.frontendurl + "/document-preview/" + this.candidateId + "/" + file.candidatedocid);
    downloadLink.setAttribute("target", "_blank");
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
}
